export default __webpack_public_path__ + "static/media/a017-market-5.d3c476c4.svg";